import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './Reducers/default-reducers/combineReducers'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'


export class HttpResponseError extends Error {
	constructor(message, status, data) {
		super(message);
		this.name = 'HttpResponseError';
		this.status = status;
		this.data = data;
	}
}

export const initialState = {
	ocps: [],
	options: {
		processos: [],
		etapas: [],
		parametros: [],
	},
}

export const reloadState = () => {
	localStorage.removeItem('state')
}

const persistConfig = {
	key: 'root',
	storage,
	blacklist: ['notification'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const preventNullPayloadMiddleware = store => next => action => {
	if ( action.payload instanceof HttpResponseError) {
		return; // bloqueia a ação
	}
	return next(action); // segue para o próximo middleware ou reducer
};

// Middleware para debugar ações de persistência
const persistDebugMiddleware = storeAPI => next => action => {
	try {
		if (action && action.type && typeof action.type === 'string' && action.type.indexOf('persist/') === 0) {
			// eslint-disable-next-line no-console
			console.log('[persist action]', action.type, action)
			// When rehydration happens, print the payload contents for inspection.
			if (action.type === 'persist/REHYDRATE') {
				try {
					// Try to stringify payload for clearer logging. Fall back to direct log if circular.
					const payload = action.payload
					let payloadStr = null
					try {
						payloadStr = JSON.stringify(payload)
					} catch (e) {
						// circular or not serializable
					}
					if (payloadStr) {
						// eslint-disable-next-line no-console
						console.log('[persist action] persist/REHYDRATE payload (stringified):', payloadStr)
					} else {
						// eslint-disable-next-line no-console
						console.log('[persist action] persist/REHYDRATE payload (raw):', payload)
					}
				} catch (e) {
					// ignore any logging errors
				}
			}
		}
	} catch (e) {}
	return next(action)
}

export const store = configureStore({
	reducer: persistedReducer,
	devTools: process.env.NODE_ENV === 'development',
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: {
				ignoredActions: [
					'persist/PERSIST',
					'persist/REHYDRATE',
					'persist/PAUSE',
					'persist/FLUSH',
					'persist/PURGE',
					'persist/REGISTER',
				],
			},
		}).concat(preventNullPayloadMiddleware, persistDebugMiddleware),
});




// Create persistor as a singleton to avoid multiple persistStore calls
const getGlobal = () => {
	try {
		if (typeof window !== 'undefined') return window
		if (typeof global !== 'undefined') return global
		// fallback
		// eslint-disable-next-line no-undef
		return this
	} catch (e) {
		return undefined
	}
}

let _persistor = null
const G = getGlobal()
try {
	if (G && G.__REDUX_PERSISTOR__) {
		_persistor = G.__REDUX_PERSISTOR__
	}
} catch (e) {
	// ignore
}

if (!_persistor) {
	_persistor = persistStore(store)
	try {
		if (G) G.__REDUX_PERSISTOR__ = _persistor
	} catch (e) {}
}

export const persistor = _persistor

// DEBUG: log identity of store and persistor to help diagnose rehydration issues
try {
	// eslint-disable-next-line no-console
	console.log('[store] store created:', store)
	// eslint-disable-next-line no-console
	console.log('[store] persistor created:', persistor)
} catch (e) {
	// ignore logging errors in environments without console
}

// Log persistor state transitions (bootstrapped / rehydration)
try {
	if (persistor && typeof persistor.subscribe === 'function') {
		persistor.subscribe(() => {
			try {
				const pState = persistor.getState && persistor.getState()
				// eslint-disable-next-line no-console
				console.log('[persistor] state:', pState)
				if (pState && pState.bootstrapped) {
					// eslint-disable-next-line no-console
					console.log('[persistor] bootstrapped: rehydration finished')
				}
			} catch (e) {}
		})
	}
} catch (e) {}
